import { GzProgressThinWebComponent } from './component/GzProgressThinWebComponent';

export { GzProgressThinWebComponent };
